module.exports = __webpack_public_path__ + "bd89b7811dc92f9935d26f993643fd8b.png";